import { Box, Container, Typography, useTheme } from '@mui/material'
import React from 'react'
import { LockerBanks } from '../components/LockerBanks'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { 
    checkIfAssignmentIsProperlyConfigured, 
    setDomainAndLockerBankIdInLocalStorage 
} from '../lib/Utils'
import { SUCCESS } from '../assets/constants/Constants'
import { getTenantAndAssignmentSettings } from '../api/api'
import { LOCKER_SLUG } from '../assets/constants/BrowserStorageKeys'

const SelectLockerBankPage = () => {
    const theme = useTheme()
    const colorScheme = theme.palette.mode
    const { t } = useTranslation()
    const history = useHistory()

    const { lockerDatas } = history.location.state || {}
    const safeLockerDatas = lockerDatas || []
    const lockerBanks = [
        ...new Map(
            safeLockerDatas.map(item => [item?.locker_bank?.id, item?.locker_bank])
        ).values()
    ]


    const getSettingsValidateAndRedirectUser = async (lockerBankId) => {
        try {
            const response = await getTenantAndAssignmentSettings(lockerBankId)

            if (response?.status === SUCCESS) {
                const data = response?.data

                if (!data) return

                const lockerslug = data?.locker_bank?.slug

                localStorage.setItem(LOCKER_SLUG, lockerslug)

                const assignments = data?.locker_assignments || []

                if (assignments.length > 1) {
                    history.push({
                        pathname: '/assignments',
                        state: { tenantAndAssignmentSettings: data }
                    })
                }

                else if (assignments.length === 1) {
                    const isValid = await checkIfAssignmentIsProperlyConfigured(data)
                    if (isValid === true) {
                        history.push('/home-screen')
                    } else {
                        alert(t(isValid?.errorMessage || 'Something went wrong'))
                    }
                }

                else {
                    alert(t('noLockerAssignments'))
                }
            }
        } catch (error) {
            console.error('Error:', error)
        }
    }

    const handleLockerClick = (locker) => {
        if (!locker?.id) return
        const domainAndLockerBankInfoObject = {
            domain: "https://euro.durolt.in/",
            lockerBankId: locker.id
        }
        setDomainAndLockerBankIdInLocalStorage(domainAndLockerBankInfoObject)
       getSettingsValidateAndRedirectUser(locker.id)
    }

    return (
        <Container className="select-locker-bank-page" maxWidth="xs">
            <Box className="main-container">
                {lockerBanks.length > 0 ? (
                    lockerBanks.map((locker) => (
                        <LockerBanks
                            key={locker.id}
                            lockerBank={locker}
                            onClick={() => handleLockerClick(locker)}
                        />
                    ))
                ) : (
                    <Typography
                        className={`no-locker-bank-text ${
                            colorScheme === 'dark' ? 'dark-text' : ""
                        }`}
                    >
                        {t('noAvailableLockerBanks')}
                    </Typography>
                )}
            </Box>
        </Container>
    )
}

export default SelectLockerBankPage
